const GraphQLQuery = require('app/graphql/Query');
const ListTable = require('app/ui/list/Table');

class AnalyseView {
    defaultOptions() {
        return {
            'selector': '.view-billing-analyse',
            'tableContainerSelector': '.billing-analyse-container',
            'filterFormSelector': '.billing-analyse-search-form',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$tableContainer = $(this.settings.tableContainerSelector,this.$container);
        this.$filterForm =  $(this.settings.filterFormSelector,this.$container);
        
        this.$unsetContainer = $('.billing-analyse-unset',this.$tableContainer);
        this.$resultContainer = $('.billing-analyse-result',this.$tableContainer);

        this.initialize();
    }

    initialize() {
        var self = this;
        
        this.initializeFilterForm();
    }

    initializeFilterForm(){
        var self = this;

        this.$filterBySuppliers = $('select[id="suppliers"]',this.$filterForm);
        this.$filterByRestaurants = $('select[name="restaurant"]',this.$filterForm);
        this.$filterFrom = $('input[name="from"]',this.$filterForm);
        this.$filterTo = $('input[name="to"]',this.$filterForm);

        window.select2(
            this.$filterBySuppliers,
            {
                'placeholder': 'Sélection de fournisseurs',
                'allowClear': true,
                'closeOnSelect': false,
            }
        );
        window.select2(
            this.$filterByRestaurants,
            {
                'placeholder': 'Sélection de restaurants',
                'allowClear': true,
                'closeOnSelect': false,
            }
        );

        this.$filterForm.on('submit',this.onSubmitFilterForm);

    }

    onSubmitFilterForm(event){
        event.preventDefault()
        event.stopPropagation();

        this.loadData();
    }

    refresh(){
        this.loadData();
    }

    isAnalysable(){
        let suppliers = this.$filterBySuppliers.val();
        let restaurants = this.$filterByRestaurants.val();
        let from = this.$filterFrom.val();
        let to = this.$filterTo.val();


        if(suppliers.length == 0 && restaurants.length == 0 && from == '' && to == ''){
            return false;
        }

        return true;
    }

    loadData(){
        this.$unsetContainer.show();


        if(this.isAnalysable()){
            this.$unsetContainer.hide();
            this.$resultContainer.show();

            let query = this.buildQuery();
            query.execute();
        }
        
    }

    buildQuery(){
        var self = this;

        
        let parameters = {
            'restaurants': this.$filterByRestaurants.val(),
            'suppliers': this.$filterBySuppliers.val(),
            'from': this.$filterFrom.val(),
            'to': this.$filterTo.val(),
        };

        let fields = [
            'type',
            'label',
            'restaurant { id name }',
            'data { supplier { id name } ht tva tva55 tva20 ttc }',
            'ht',
            'tva',
            'tva55',
            'tva20',
            'ttc',
        ];

        return new GraphQLQuery({
            //parameters
            'queryType': 'restaurantOrderAnalyseBilling',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,

            //callbacks
            'before': function(){
                self.$resultContainer
                .html('')
                .append(window.App.generateLoader(true));
            },
            'success': function(data){
                self.drawAnalyse(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

    }

    drawAnalyse(data){
        
        let $table = $('<table/>')
        .addClass('table table-striped table-bordered table-condensed table-responsive large-table');

        let $tbody = $('<tbody/>');
        let $thead = $('<thead/>');
        let $tfoot = $('<tfoot/>');

        let $headerRow = $('<tr/>');
        $thead.append($headerRow);

        $headerRow.append($('<th/>').append(''));

        let suppliersEmpty = [];
        for(let line of data){
            let type = line.type;
            let suppliersData = line.data;
            let $row = $('<tr/>');
            switch(type){
                case 'restaurant':
                    if(line.ht > 0){
                        let restaurant = line.restaurant;
                        $row.append(
                            $('<td/>')
                            .addClass('text-bold')
                            .append(restaurant.name)
                        );

                        for(let supplierData of suppliersData){
                            let supplier = supplierData.supplier;

                            let ht = supplierData.ht;
                            let $cell = $('<td/>')
                            .attr('data-supplier',supplier.id)
                            .append(
                                $('<div/>').append(window.formatFloat(ht)+ " &euro;")
                            )
                            $row.append($cell);
                        }

                        $row
                        .append(
                            $('<td/>')
                            .addClass('text-bold')
                            .append(window.formatFloat(line.ht)+ " &euro;")
                        )

                        
                        $tbody.append($row);
                    }
                break;

                case 'total':
                    $row
                    .append(
                        $('<td/>')
                        .addClass('text-bold')
                        .append('Totaux')
                    )
                    
                    for(let supplierData of suppliersData){
                        let supplier = supplierData.supplier;

                        $headerRow
                        .append(
                            $('<th/>')
                            .attr('data-supplier',supplier.id)
                            .addClass('text-bold')
                            .append(supplier.name)
                        );

                        let ht = supplierData.ht;
                        let tva55 = supplierData.tva55;
                        let tva20 = supplierData.tva20;
                        let ttc = supplierData.ttc;

                        if(ht <= 0){
                            suppliersEmpty.push(supplier.id);
                        }

                        let $supplierTotal = $('<ul/>')
                        .addClass('list-unstyled');

                        $supplierTotal
                        .append(
                            $('<li>')
                            .append(window.formatFloat(ht)+ " &euro;")
                        )
                        .append(
                            $('<li/>').append("TVA 5,50% : "+window.formatFloat(tva55)+ " &euro;")
                        )
                        .append(
                            $('<li/>').append("TVA 20% : "+window.formatFloat(tva20)+ " &euro;")
                        )
                        .append(
                            $('<li/>').append("TTC : "+window.formatFloat(ttc)+ " &euro;")
                        )

                        $row.append(
                            $('<td/>')
                            .attr('data-supplier',supplier.id)
                            .addClass('text-bold')
                            .append($supplierTotal)
                        );
                    }

                    let $globalTotal = $('<ul/>')
                    .addClass('list-unstyled')
                    .append(
                        $('<li>')
                        .append(window.formatFloat(line.ht)+ " &euro;")
                    )
                    .append(
                        $('<li/>').append("TVA 5,50% : "+window.formatFloat(line.tva55)+ " &euro;")
                    )
                    .append(
                        $('<li/>').append("TVA 20% : "+window.formatFloat(line.tva20)+ " &euro;")
                    )
                    .append(
                        $('<li/>')
                        .append("TTC : "+window.formatFloat(line.ttc)+ " &euro;")
                    )
                    
                    $row
                    .append(
                        $('<td/>')
                        .addClass('text-bold')
                        .append(
                            $globalTotal
                        )
                    )

                    $tfoot.append($row);
                break;
            }
        }
        
        $headerRow.append(
            $('<th/>')
            .addClass('text-bold')
            .append("Totaux")
        );


        $table
        .append($thead)
        .append($tbody)
        .append($tfoot);


        for(let id of suppliersEmpty){
            $('td[data-supplier="'+id+'"]',$table).hide();
            $('th[data-supplier="'+id+'"]',$table).hide();
        }

        this.$resultContainer
        .html('')
        .append($table);
    }
}

module.exports = AnalyseView;